// source: messages/benefits.message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_type_decimal_pb = require('../google/type/decimal_pb.js');
goog.object.extend(proto, google_type_decimal_pb);
goog.exportSymbol('proto.benefits_messages.BenefitCodeEntry', null, global);
goog.exportSymbol('proto.benefits_messages.BillingTypeEnum', null, global);
goog.exportSymbol('proto.benefits_messages.FetchBenefitCodesRequest', null, global);
goog.exportSymbol('proto.benefits_messages.FetchBenefitCodesResponse', null, global);
goog.exportSymbol('proto.benefits_messages.GetLegalBenefitByIdRequest', null, global);
goog.exportSymbol('proto.benefits_messages.GetLegalBenefitByIdResponse', null, global);
goog.exportSymbol('proto.benefits_messages.LegalBenefit', null, global);
goog.exportSymbol('proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest', null, global);
goog.exportSymbol('proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse', null, global);
goog.exportSymbol('proto.benefits_messages.ListLegalBenefitsRequest', null, global);
goog.exportSymbol('proto.benefits_messages.ListLegalBenefitsResponse', null, global);
goog.exportSymbol('proto.benefits_messages.ListMatterBillingCodesRequest', null, global);
goog.exportSymbol('proto.benefits_messages.ListMatterBillingCodesResponse', null, global);
goog.exportSymbol('proto.benefits_messages.MatterBillingCode', null, global);
goog.exportSymbol('proto.benefits_messages.UsesPerYearDefinition', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.benefits_messages.LegalBenefit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.benefits_messages.LegalBenefit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.benefits_messages.LegalBenefit.displayName = 'proto.benefits_messages.LegalBenefit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.benefits_messages.GetLegalBenefitByIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.benefits_messages.GetLegalBenefitByIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.benefits_messages.GetLegalBenefitByIdRequest.displayName = 'proto.benefits_messages.GetLegalBenefitByIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.benefits_messages.GetLegalBenefitByIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.benefits_messages.GetLegalBenefitByIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.benefits_messages.GetLegalBenefitByIdResponse.displayName = 'proto.benefits_messages.GetLegalBenefitByIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.benefits_messages.ListLegalBenefitsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.benefits_messages.ListLegalBenefitsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.benefits_messages.ListLegalBenefitsRequest.displayName = 'proto.benefits_messages.ListLegalBenefitsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.benefits_messages.ListLegalBenefitsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.benefits_messages.ListLegalBenefitsResponse.repeatedFields_, null);
};
goog.inherits(proto.benefits_messages.ListLegalBenefitsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.benefits_messages.ListLegalBenefitsResponse.displayName = 'proto.benefits_messages.ListLegalBenefitsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.benefits_messages.MatterBillingCode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.benefits_messages.MatterBillingCode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.benefits_messages.MatterBillingCode.displayName = 'proto.benefits_messages.MatterBillingCode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.benefits_messages.ListMatterBillingCodesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.benefits_messages.ListMatterBillingCodesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.benefits_messages.ListMatterBillingCodesRequest.displayName = 'proto.benefits_messages.ListMatterBillingCodesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.benefits_messages.ListMatterBillingCodesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.benefits_messages.ListMatterBillingCodesResponse.repeatedFields_, null);
};
goog.inherits(proto.benefits_messages.ListMatterBillingCodesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.benefits_messages.ListMatterBillingCodesResponse.displayName = 'proto.benefits_messages.ListMatterBillingCodesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.benefits_messages.FetchBenefitCodesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.benefits_messages.FetchBenefitCodesRequest.repeatedFields_, null);
};
goog.inherits(proto.benefits_messages.FetchBenefitCodesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.benefits_messages.FetchBenefitCodesRequest.displayName = 'proto.benefits_messages.FetchBenefitCodesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.benefits_messages.BenefitCodeEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.benefits_messages.BenefitCodeEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.benefits_messages.BenefitCodeEntry.displayName = 'proto.benefits_messages.BenefitCodeEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.benefits_messages.FetchBenefitCodesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.benefits_messages.FetchBenefitCodesResponse.repeatedFields_, null);
};
goog.inherits(proto.benefits_messages.FetchBenefitCodesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.benefits_messages.FetchBenefitCodesResponse.displayName = 'proto.benefits_messages.FetchBenefitCodesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest.repeatedFields_, null);
};
goog.inherits(proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest.displayName = 'proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse.repeatedFields_, null);
};
goog.inherits(proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse.displayName = 'proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.benefits_messages.LegalBenefit.prototype.toObject = function(opt_includeInstance) {
  return proto.benefits_messages.LegalBenefit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.benefits_messages.LegalBenefit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.LegalBenefit.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
matterBillingCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
matterTitle: jspb.Message.getFieldWithDefault(msg, 3, ""),
matterBenefitDescription: jspb.Message.getFieldWithDefault(msg, 4, ""),
matterPaymentParameters: jspb.Message.getFieldWithDefault(msg, 28, ""),
hourlyRate: (f = msg.getHourlyRate()) && google_type_decimal_pb.Decimal.toObject(includeInstance, f),
totalHours: (f = msg.getTotalHours()) && google_type_decimal_pb.Decimal.toObject(includeInstance, f),
totalAmount: (f = msg.getTotalAmount()) && google_type_decimal_pb.Decimal.toObject(includeInstance, f),
raterMaxRate: (f = msg.getRaterMaxRate()) && google_type_decimal_pb.Decimal.toObject(includeInstance, f),
matterLimitations: jspb.Message.getFieldWithDefault(msg, 9, ""),
paidInFull: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
coversEligibleParents: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
usesPerYear: (f = jspb.Message.getField(msg, 12)) == null ? undefined : f,
matterSpecialInstructions: jspb.Message.getFieldWithDefault(msg, 13, ""),
providerInstructions: (f = jspb.Message.getField(msg, 14)) == null ? undefined : f,
hasOverride: (f = jspb.Message.getBooleanField(msg, 15)) == null ? undefined : f,
isestateplanning: jspb.Message.getBooleanFieldWithDefault(msg, 25, false),
groupTitle: (f = jspb.Message.getField(msg, 26)) == null ? undefined : f,
requireSupportingDocuments: jspb.Message.getBooleanFieldWithDefault(msg, 27, false),
isBillable: jspb.Message.getBooleanFieldWithDefault(msg, 31, false),
primarymember: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
spouse: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
domesticpartner: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
dependantchild: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
elderparent: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
usesPerYearDefinition: (f = jspb.Message.getField(msg, 22)) == null ? undefined : f,
billingtype: (f = jspb.Message.getField(msg, 23)) == null ? undefined : f,
lgpolicyid: (f = jspb.Message.getField(msg, 24)) == null ? undefined : f,
providerStandardHourlyRate: (f = msg.getProviderStandardHourlyRate()) && google_type_decimal_pb.Decimal.toObject(includeInstance, f),
providerStandardFlatRate: (f = msg.getProviderStandardFlatRate()) && google_type_decimal_pb.Decimal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.benefits_messages.LegalBenefit}
 */
proto.benefits_messages.LegalBenefit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.benefits_messages.LegalBenefit;
  return proto.benefits_messages.LegalBenefit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.benefits_messages.LegalBenefit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.benefits_messages.LegalBenefit}
 */
proto.benefits_messages.LegalBenefit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatterBillingCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatterTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatterBenefitDescription(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatterPaymentParameters(value);
      break;
    case 5:
      var value = new google_type_decimal_pb.Decimal;
      reader.readMessage(value,google_type_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setHourlyRate(value);
      break;
    case 6:
      var value = new google_type_decimal_pb.Decimal;
      reader.readMessage(value,google_type_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setTotalHours(value);
      break;
    case 7:
      var value = new google_type_decimal_pb.Decimal;
      reader.readMessage(value,google_type_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setTotalAmount(value);
      break;
    case 8:
      var value = new google_type_decimal_pb.Decimal;
      reader.readMessage(value,google_type_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setRaterMaxRate(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatterLimitations(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaidInFull(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCoversEligibleParents(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUsesPerYear(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatterSpecialInstructions(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setProviderInstructions(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasOverride(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsestateplanning(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupTitle(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequireSupportingDocuments(value);
      break;
    case 31:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsBillable(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPrimarymember(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSpouse(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDomesticpartner(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDependantchild(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setElderparent(value);
      break;
    case 22:
      var value = /** @type {!proto.benefits_messages.UsesPerYearDefinition} */ (reader.readEnum());
      msg.setUsesPerYearDefinition(value);
      break;
    case 23:
      var value = /** @type {!proto.benefits_messages.BillingTypeEnum} */ (reader.readEnum());
      msg.setBillingtype(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLgpolicyid(value);
      break;
    case 29:
      var value = new google_type_decimal_pb.Decimal;
      reader.readMessage(value,google_type_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProviderStandardHourlyRate(value);
      break;
    case 30:
      var value = new google_type_decimal_pb.Decimal;
      reader.readMessage(value,google_type_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProviderStandardFlatRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.benefits_messages.LegalBenefit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.benefits_messages.LegalBenefit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.benefits_messages.LegalBenefit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.LegalBenefit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMatterBillingCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMatterTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMatterBenefitDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMatterPaymentParameters();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getHourlyRate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_type_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getTotalHours();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_type_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getTotalAmount();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_type_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getRaterMaxRate();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_type_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getMatterLimitations();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPaidInFull();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getCoversEligibleParents();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getMatterSpecialInstructions();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeString(
      14,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getIsestateplanning();
  if (f) {
    writer.writeBool(
      25,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 26));
  if (f != null) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getRequireSupportingDocuments();
  if (f) {
    writer.writeBool(
      27,
      f
    );
  }
  f = message.getIsBillable();
  if (f) {
    writer.writeBool(
      31,
      f
    );
  }
  f = message.getPrimarymember();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getSpouse();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getDomesticpartner();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getDependantchild();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getElderparent();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = /** @type {!proto.benefits_messages.UsesPerYearDefinition} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeEnum(
      22,
      f
    );
  }
  f = /** @type {!proto.benefits_messages.BillingTypeEnum} */ (jspb.Message.getField(message, 23));
  if (f != null) {
    writer.writeEnum(
      23,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 24));
  if (f != null) {
    writer.writeInt32(
      24,
      f
    );
  }
  f = message.getProviderStandardHourlyRate();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      google_type_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getProviderStandardFlatRate();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      google_type_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.benefits_messages.LegalBenefit.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string matter_billing_code = 2;
 * @return {string}
 */
proto.benefits_messages.LegalBenefit.prototype.getMatterBillingCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setMatterBillingCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string matter_title = 3;
 * @return {string}
 */
proto.benefits_messages.LegalBenefit.prototype.getMatterTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setMatterTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string matter_benefit_description = 4;
 * @return {string}
 */
proto.benefits_messages.LegalBenefit.prototype.getMatterBenefitDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setMatterBenefitDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string matter_payment_parameters = 28;
 * @return {string}
 */
proto.benefits_messages.LegalBenefit.prototype.getMatterPaymentParameters = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setMatterPaymentParameters = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional google.type.Decimal hourly_rate = 5;
 * @return {?proto.google.type.Decimal}
 */
proto.benefits_messages.LegalBenefit.prototype.getHourlyRate = function() {
  return /** @type{?proto.google.type.Decimal} */ (
    jspb.Message.getWrapperField(this, google_type_decimal_pb.Decimal, 5));
};


/**
 * @param {?proto.google.type.Decimal|undefined} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
*/
proto.benefits_messages.LegalBenefit.prototype.setHourlyRate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.clearHourlyRate = function() {
  return this.setHourlyRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.hasHourlyRate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.type.Decimal total_hours = 6;
 * @return {?proto.google.type.Decimal}
 */
proto.benefits_messages.LegalBenefit.prototype.getTotalHours = function() {
  return /** @type{?proto.google.type.Decimal} */ (
    jspb.Message.getWrapperField(this, google_type_decimal_pb.Decimal, 6));
};


/**
 * @param {?proto.google.type.Decimal|undefined} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
*/
proto.benefits_messages.LegalBenefit.prototype.setTotalHours = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.clearTotalHours = function() {
  return this.setTotalHours(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.hasTotalHours = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.type.Decimal total_amount = 7;
 * @return {?proto.google.type.Decimal}
 */
proto.benefits_messages.LegalBenefit.prototype.getTotalAmount = function() {
  return /** @type{?proto.google.type.Decimal} */ (
    jspb.Message.getWrapperField(this, google_type_decimal_pb.Decimal, 7));
};


/**
 * @param {?proto.google.type.Decimal|undefined} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
*/
proto.benefits_messages.LegalBenefit.prototype.setTotalAmount = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.clearTotalAmount = function() {
  return this.setTotalAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.hasTotalAmount = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.type.Decimal rater_max_rate = 8;
 * @return {?proto.google.type.Decimal}
 */
proto.benefits_messages.LegalBenefit.prototype.getRaterMaxRate = function() {
  return /** @type{?proto.google.type.Decimal} */ (
    jspb.Message.getWrapperField(this, google_type_decimal_pb.Decimal, 8));
};


/**
 * @param {?proto.google.type.Decimal|undefined} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
*/
proto.benefits_messages.LegalBenefit.prototype.setRaterMaxRate = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.clearRaterMaxRate = function() {
  return this.setRaterMaxRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.hasRaterMaxRate = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string matter_limitations = 9;
 * @return {string}
 */
proto.benefits_messages.LegalBenefit.prototype.getMatterLimitations = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setMatterLimitations = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool paid_in_full = 10;
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.getPaidInFull = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setPaidInFull = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool covers_eligible_parents = 11;
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.getCoversEligibleParents = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setCoversEligibleParents = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional int32 uses_per_year = 12;
 * @return {number}
 */
proto.benefits_messages.LegalBenefit.prototype.getUsesPerYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setUsesPerYear = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.clearUsesPerYear = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.hasUsesPerYear = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string matter_special_instructions = 13;
 * @return {string}
 */
proto.benefits_messages.LegalBenefit.prototype.getMatterSpecialInstructions = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setMatterSpecialInstructions = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string provider_instructions = 14;
 * @return {string}
 */
proto.benefits_messages.LegalBenefit.prototype.getProviderInstructions = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setProviderInstructions = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.clearProviderInstructions = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.hasProviderInstructions = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional bool has_override = 15;
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.getHasOverride = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setHasOverride = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.clearHasOverride = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.hasHasOverride = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional bool isEstatePlanning = 25;
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.getIsestateplanning = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setIsestateplanning = function(value) {
  return jspb.Message.setProto3BooleanField(this, 25, value);
};


/**
 * optional string group_title = 26;
 * @return {string}
 */
proto.benefits_messages.LegalBenefit.prototype.getGroupTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setGroupTitle = function(value) {
  return jspb.Message.setField(this, 26, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.clearGroupTitle = function() {
  return jspb.Message.setField(this, 26, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.hasGroupTitle = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional bool require_supporting_documents = 27;
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.getRequireSupportingDocuments = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setRequireSupportingDocuments = function(value) {
  return jspb.Message.setProto3BooleanField(this, 27, value);
};


/**
 * optional bool is_billable = 31;
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.getIsBillable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 31, false));
};


/**
 * @param {boolean} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setIsBillable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 31, value);
};


/**
 * optional bool primaryMember = 17;
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.getPrimarymember = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setPrimarymember = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * optional bool spouse = 18;
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.getSpouse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setSpouse = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * optional bool domesticPartner = 19;
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.getDomesticpartner = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setDomesticpartner = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional bool dependantChild = 20;
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.getDependantchild = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setDependantchild = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional bool elderParent = 21;
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.getElderparent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setElderparent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional UsesPerYearDefinition uses_per_year_definition = 22;
 * @return {!proto.benefits_messages.UsesPerYearDefinition}
 */
proto.benefits_messages.LegalBenefit.prototype.getUsesPerYearDefinition = function() {
  return /** @type {!proto.benefits_messages.UsesPerYearDefinition} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {!proto.benefits_messages.UsesPerYearDefinition} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setUsesPerYearDefinition = function(value) {
  return jspb.Message.setField(this, 22, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.clearUsesPerYearDefinition = function() {
  return jspb.Message.setField(this, 22, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.hasUsesPerYearDefinition = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional BillingTypeEnum billingType = 23;
 * @return {!proto.benefits_messages.BillingTypeEnum}
 */
proto.benefits_messages.LegalBenefit.prototype.getBillingtype = function() {
  return /** @type {!proto.benefits_messages.BillingTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {!proto.benefits_messages.BillingTypeEnum} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setBillingtype = function(value) {
  return jspb.Message.setField(this, 23, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.clearBillingtype = function() {
  return jspb.Message.setField(this, 23, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.hasBillingtype = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional int32 lgPolicyId = 24;
 * @return {number}
 */
proto.benefits_messages.LegalBenefit.prototype.getLgpolicyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.setLgpolicyid = function(value) {
  return jspb.Message.setField(this, 24, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.clearLgpolicyid = function() {
  return jspb.Message.setField(this, 24, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.hasLgpolicyid = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional google.type.Decimal provider_standard_hourly_rate = 29;
 * @return {?proto.google.type.Decimal}
 */
proto.benefits_messages.LegalBenefit.prototype.getProviderStandardHourlyRate = function() {
  return /** @type{?proto.google.type.Decimal} */ (
    jspb.Message.getWrapperField(this, google_type_decimal_pb.Decimal, 29));
};


/**
 * @param {?proto.google.type.Decimal|undefined} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
*/
proto.benefits_messages.LegalBenefit.prototype.setProviderStandardHourlyRate = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.clearProviderStandardHourlyRate = function() {
  return this.setProviderStandardHourlyRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.hasProviderStandardHourlyRate = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional google.type.Decimal provider_standard_flat_rate = 30;
 * @return {?proto.google.type.Decimal}
 */
proto.benefits_messages.LegalBenefit.prototype.getProviderStandardFlatRate = function() {
  return /** @type{?proto.google.type.Decimal} */ (
    jspb.Message.getWrapperField(this, google_type_decimal_pb.Decimal, 30));
};


/**
 * @param {?proto.google.type.Decimal|undefined} value
 * @return {!proto.benefits_messages.LegalBenefit} returns this
*/
proto.benefits_messages.LegalBenefit.prototype.setProviderStandardFlatRate = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.benefits_messages.LegalBenefit} returns this
 */
proto.benefits_messages.LegalBenefit.prototype.clearProviderStandardFlatRate = function() {
  return this.setProviderStandardFlatRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.LegalBenefit.prototype.hasProviderStandardFlatRate = function() {
  return jspb.Message.getField(this, 30) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.benefits_messages.GetLegalBenefitByIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.benefits_messages.GetLegalBenefitByIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.benefits_messages.GetLegalBenefitByIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.GetLegalBenefitByIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
attyId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
caseId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.benefits_messages.GetLegalBenefitByIdRequest}
 */
proto.benefits_messages.GetLegalBenefitByIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.benefits_messages.GetLegalBenefitByIdRequest;
  return proto.benefits_messages.GetLegalBenefitByIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.benefits_messages.GetLegalBenefitByIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.benefits_messages.GetLegalBenefitByIdRequest}
 */
proto.benefits_messages.GetLegalBenefitByIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttyId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCaseId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.benefits_messages.GetLegalBenefitByIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.benefits_messages.GetLegalBenefitByIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.benefits_messages.GetLegalBenefitByIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.GetLegalBenefitByIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.benefits_messages.GetLegalBenefitByIdRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.benefits_messages.GetLegalBenefitByIdRequest} returns this
 */
proto.benefits_messages.GetLegalBenefitByIdRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 atty_id = 2;
 * @return {number}
 */
proto.benefits_messages.GetLegalBenefitByIdRequest.prototype.getAttyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.benefits_messages.GetLegalBenefitByIdRequest} returns this
 */
proto.benefits_messages.GetLegalBenefitByIdRequest.prototype.setAttyId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.benefits_messages.GetLegalBenefitByIdRequest} returns this
 */
proto.benefits_messages.GetLegalBenefitByIdRequest.prototype.clearAttyId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.GetLegalBenefitByIdRequest.prototype.hasAttyId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 case_id = 3;
 * @return {number}
 */
proto.benefits_messages.GetLegalBenefitByIdRequest.prototype.getCaseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.benefits_messages.GetLegalBenefitByIdRequest} returns this
 */
proto.benefits_messages.GetLegalBenefitByIdRequest.prototype.setCaseId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.benefits_messages.GetLegalBenefitByIdRequest} returns this
 */
proto.benefits_messages.GetLegalBenefitByIdRequest.prototype.clearCaseId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.GetLegalBenefitByIdRequest.prototype.hasCaseId = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.benefits_messages.GetLegalBenefitByIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.benefits_messages.GetLegalBenefitByIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.benefits_messages.GetLegalBenefitByIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.GetLegalBenefitByIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
benefit: (f = msg.getBenefit()) && proto.benefits_messages.LegalBenefit.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.benefits_messages.GetLegalBenefitByIdResponse}
 */
proto.benefits_messages.GetLegalBenefitByIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.benefits_messages.GetLegalBenefitByIdResponse;
  return proto.benefits_messages.GetLegalBenefitByIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.benefits_messages.GetLegalBenefitByIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.benefits_messages.GetLegalBenefitByIdResponse}
 */
proto.benefits_messages.GetLegalBenefitByIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.benefits_messages.LegalBenefit;
      reader.readMessage(value,proto.benefits_messages.LegalBenefit.deserializeBinaryFromReader);
      msg.setBenefit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.benefits_messages.GetLegalBenefitByIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.benefits_messages.GetLegalBenefitByIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.benefits_messages.GetLegalBenefitByIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.GetLegalBenefitByIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBenefit();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.benefits_messages.LegalBenefit.serializeBinaryToWriter
    );
  }
};


/**
 * optional LegalBenefit benefit = 1;
 * @return {?proto.benefits_messages.LegalBenefit}
 */
proto.benefits_messages.GetLegalBenefitByIdResponse.prototype.getBenefit = function() {
  return /** @type{?proto.benefits_messages.LegalBenefit} */ (
    jspb.Message.getWrapperField(this, proto.benefits_messages.LegalBenefit, 1));
};


/**
 * @param {?proto.benefits_messages.LegalBenefit|undefined} value
 * @return {!proto.benefits_messages.GetLegalBenefitByIdResponse} returns this
*/
proto.benefits_messages.GetLegalBenefitByIdResponse.prototype.setBenefit = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.benefits_messages.GetLegalBenefitByIdResponse} returns this
 */
proto.benefits_messages.GetLegalBenefitByIdResponse.prototype.clearBenefit = function() {
  return this.setBenefit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.GetLegalBenefitByIdResponse.prototype.hasBenefit = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.benefits_messages.ListLegalBenefitsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.benefits_messages.ListLegalBenefitsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.benefits_messages.ListLegalBenefitsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.ListLegalBenefitsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
lgPolicyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
attyId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
caseId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.benefits_messages.ListLegalBenefitsRequest}
 */
proto.benefits_messages.ListLegalBenefitsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.benefits_messages.ListLegalBenefitsRequest;
  return proto.benefits_messages.ListLegalBenefitsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.benefits_messages.ListLegalBenefitsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.benefits_messages.ListLegalBenefitsRequest}
 */
proto.benefits_messages.ListLegalBenefitsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLgPolicyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttyId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCaseId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.benefits_messages.ListLegalBenefitsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.benefits_messages.ListLegalBenefitsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.benefits_messages.ListLegalBenefitsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.ListLegalBenefitsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLgPolicyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 lg_policy_id = 1;
 * @return {number}
 */
proto.benefits_messages.ListLegalBenefitsRequest.prototype.getLgPolicyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.benefits_messages.ListLegalBenefitsRequest} returns this
 */
proto.benefits_messages.ListLegalBenefitsRequest.prototype.setLgPolicyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 atty_id = 2;
 * @return {number}
 */
proto.benefits_messages.ListLegalBenefitsRequest.prototype.getAttyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.benefits_messages.ListLegalBenefitsRequest} returns this
 */
proto.benefits_messages.ListLegalBenefitsRequest.prototype.setAttyId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.benefits_messages.ListLegalBenefitsRequest} returns this
 */
proto.benefits_messages.ListLegalBenefitsRequest.prototype.clearAttyId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.ListLegalBenefitsRequest.prototype.hasAttyId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 case_id = 3;
 * @return {number}
 */
proto.benefits_messages.ListLegalBenefitsRequest.prototype.getCaseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.benefits_messages.ListLegalBenefitsRequest} returns this
 */
proto.benefits_messages.ListLegalBenefitsRequest.prototype.setCaseId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.benefits_messages.ListLegalBenefitsRequest} returns this
 */
proto.benefits_messages.ListLegalBenefitsRequest.prototype.clearCaseId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.benefits_messages.ListLegalBenefitsRequest.prototype.hasCaseId = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.benefits_messages.ListLegalBenefitsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.benefits_messages.ListLegalBenefitsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.benefits_messages.ListLegalBenefitsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.benefits_messages.ListLegalBenefitsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.ListLegalBenefitsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
benefitsList: jspb.Message.toObjectList(msg.getBenefitsList(),
    proto.benefits_messages.LegalBenefit.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.benefits_messages.ListLegalBenefitsResponse}
 */
proto.benefits_messages.ListLegalBenefitsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.benefits_messages.ListLegalBenefitsResponse;
  return proto.benefits_messages.ListLegalBenefitsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.benefits_messages.ListLegalBenefitsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.benefits_messages.ListLegalBenefitsResponse}
 */
proto.benefits_messages.ListLegalBenefitsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.benefits_messages.LegalBenefit;
      reader.readMessage(value,proto.benefits_messages.LegalBenefit.deserializeBinaryFromReader);
      msg.addBenefits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.benefits_messages.ListLegalBenefitsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.benefits_messages.ListLegalBenefitsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.benefits_messages.ListLegalBenefitsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.ListLegalBenefitsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBenefitsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.benefits_messages.LegalBenefit.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LegalBenefit benefits = 1;
 * @return {!Array<!proto.benefits_messages.LegalBenefit>}
 */
proto.benefits_messages.ListLegalBenefitsResponse.prototype.getBenefitsList = function() {
  return /** @type{!Array<!proto.benefits_messages.LegalBenefit>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.benefits_messages.LegalBenefit, 1));
};


/**
 * @param {!Array<!proto.benefits_messages.LegalBenefit>} value
 * @return {!proto.benefits_messages.ListLegalBenefitsResponse} returns this
*/
proto.benefits_messages.ListLegalBenefitsResponse.prototype.setBenefitsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.benefits_messages.LegalBenefit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.benefits_messages.LegalBenefit}
 */
proto.benefits_messages.ListLegalBenefitsResponse.prototype.addBenefits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.benefits_messages.LegalBenefit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.benefits_messages.ListLegalBenefitsResponse} returns this
 */
proto.benefits_messages.ListLegalBenefitsResponse.prototype.clearBenefitsList = function() {
  return this.setBenefitsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.benefits_messages.MatterBillingCode.prototype.toObject = function(opt_includeInstance) {
  return proto.benefits_messages.MatterBillingCode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.benefits_messages.MatterBillingCode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.MatterBillingCode.toObject = function(includeInstance, msg) {
  var f, obj = {
matterBillingCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
matterTitle: jspb.Message.getFieldWithDefault(msg, 2, ""),
isBillable: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.benefits_messages.MatterBillingCode}
 */
proto.benefits_messages.MatterBillingCode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.benefits_messages.MatterBillingCode;
  return proto.benefits_messages.MatterBillingCode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.benefits_messages.MatterBillingCode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.benefits_messages.MatterBillingCode}
 */
proto.benefits_messages.MatterBillingCode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatterBillingCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatterTitle(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsBillable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.benefits_messages.MatterBillingCode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.benefits_messages.MatterBillingCode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.benefits_messages.MatterBillingCode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.MatterBillingCode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatterBillingCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMatterTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsBillable();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string matter_billing_code = 1;
 * @return {string}
 */
proto.benefits_messages.MatterBillingCode.prototype.getMatterBillingCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.benefits_messages.MatterBillingCode} returns this
 */
proto.benefits_messages.MatterBillingCode.prototype.setMatterBillingCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string matter_title = 2;
 * @return {string}
 */
proto.benefits_messages.MatterBillingCode.prototype.getMatterTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.benefits_messages.MatterBillingCode} returns this
 */
proto.benefits_messages.MatterBillingCode.prototype.setMatterTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_billable = 3;
 * @return {boolean}
 */
proto.benefits_messages.MatterBillingCode.prototype.getIsBillable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.benefits_messages.MatterBillingCode} returns this
 */
proto.benefits_messages.MatterBillingCode.prototype.setIsBillable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.benefits_messages.ListMatterBillingCodesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.benefits_messages.ListMatterBillingCodesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.benefits_messages.ListMatterBillingCodesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.ListMatterBillingCodesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.benefits_messages.ListMatterBillingCodesRequest}
 */
proto.benefits_messages.ListMatterBillingCodesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.benefits_messages.ListMatterBillingCodesRequest;
  return proto.benefits_messages.ListMatterBillingCodesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.benefits_messages.ListMatterBillingCodesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.benefits_messages.ListMatterBillingCodesRequest}
 */
proto.benefits_messages.ListMatterBillingCodesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.benefits_messages.ListMatterBillingCodesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.benefits_messages.ListMatterBillingCodesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.benefits_messages.ListMatterBillingCodesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.ListMatterBillingCodesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.benefits_messages.ListMatterBillingCodesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.benefits_messages.ListMatterBillingCodesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.benefits_messages.ListMatterBillingCodesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.benefits_messages.ListMatterBillingCodesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.ListMatterBillingCodesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
matterBillingCodesList: jspb.Message.toObjectList(msg.getMatterBillingCodesList(),
    proto.benefits_messages.MatterBillingCode.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.benefits_messages.ListMatterBillingCodesResponse}
 */
proto.benefits_messages.ListMatterBillingCodesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.benefits_messages.ListMatterBillingCodesResponse;
  return proto.benefits_messages.ListMatterBillingCodesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.benefits_messages.ListMatterBillingCodesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.benefits_messages.ListMatterBillingCodesResponse}
 */
proto.benefits_messages.ListMatterBillingCodesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.benefits_messages.MatterBillingCode;
      reader.readMessage(value,proto.benefits_messages.MatterBillingCode.deserializeBinaryFromReader);
      msg.addMatterBillingCodes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.benefits_messages.ListMatterBillingCodesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.benefits_messages.ListMatterBillingCodesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.benefits_messages.ListMatterBillingCodesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.ListMatterBillingCodesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatterBillingCodesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.benefits_messages.MatterBillingCode.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MatterBillingCode matter_billing_codes = 1;
 * @return {!Array<!proto.benefits_messages.MatterBillingCode>}
 */
proto.benefits_messages.ListMatterBillingCodesResponse.prototype.getMatterBillingCodesList = function() {
  return /** @type{!Array<!proto.benefits_messages.MatterBillingCode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.benefits_messages.MatterBillingCode, 1));
};


/**
 * @param {!Array<!proto.benefits_messages.MatterBillingCode>} value
 * @return {!proto.benefits_messages.ListMatterBillingCodesResponse} returns this
*/
proto.benefits_messages.ListMatterBillingCodesResponse.prototype.setMatterBillingCodesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.benefits_messages.MatterBillingCode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.benefits_messages.MatterBillingCode}
 */
proto.benefits_messages.ListMatterBillingCodesResponse.prototype.addMatterBillingCodes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.benefits_messages.MatterBillingCode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.benefits_messages.ListMatterBillingCodesResponse} returns this
 */
proto.benefits_messages.ListMatterBillingCodesResponse.prototype.clearMatterBillingCodesList = function() {
  return this.setMatterBillingCodesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.benefits_messages.FetchBenefitCodesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.benefits_messages.FetchBenefitCodesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.benefits_messages.FetchBenefitCodesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.benefits_messages.FetchBenefitCodesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.FetchBenefitCodesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.benefits_messages.FetchBenefitCodesRequest}
 */
proto.benefits_messages.FetchBenefitCodesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.benefits_messages.FetchBenefitCodesRequest;
  return proto.benefits_messages.FetchBenefitCodesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.benefits_messages.FetchBenefitCodesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.benefits_messages.FetchBenefitCodesRequest}
 */
proto.benefits_messages.FetchBenefitCodesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.benefits_messages.FetchBenefitCodesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.benefits_messages.FetchBenefitCodesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.benefits_messages.FetchBenefitCodesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.FetchBenefitCodesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 ids = 1;
 * @return {!Array<number>}
 */
proto.benefits_messages.FetchBenefitCodesRequest.prototype.getIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.benefits_messages.FetchBenefitCodesRequest} returns this
 */
proto.benefits_messages.FetchBenefitCodesRequest.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.benefits_messages.FetchBenefitCodesRequest} returns this
 */
proto.benefits_messages.FetchBenefitCodesRequest.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.benefits_messages.FetchBenefitCodesRequest} returns this
 */
proto.benefits_messages.FetchBenefitCodesRequest.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.benefits_messages.BenefitCodeEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.benefits_messages.BenefitCodeEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.benefits_messages.BenefitCodeEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.BenefitCodeEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
legalBenefitId: jspb.Message.getFieldWithDefault(msg, 1, 0),
matterBillingCode: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.benefits_messages.BenefitCodeEntry}
 */
proto.benefits_messages.BenefitCodeEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.benefits_messages.BenefitCodeEntry;
  return proto.benefits_messages.BenefitCodeEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.benefits_messages.BenefitCodeEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.benefits_messages.BenefitCodeEntry}
 */
proto.benefits_messages.BenefitCodeEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLegalBenefitId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatterBillingCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.benefits_messages.BenefitCodeEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.benefits_messages.BenefitCodeEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.benefits_messages.BenefitCodeEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.BenefitCodeEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLegalBenefitId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMatterBillingCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 legal_benefit_id = 1;
 * @return {number}
 */
proto.benefits_messages.BenefitCodeEntry.prototype.getLegalBenefitId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.benefits_messages.BenefitCodeEntry} returns this
 */
proto.benefits_messages.BenefitCodeEntry.prototype.setLegalBenefitId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string matter_billing_code = 2;
 * @return {string}
 */
proto.benefits_messages.BenefitCodeEntry.prototype.getMatterBillingCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.benefits_messages.BenefitCodeEntry} returns this
 */
proto.benefits_messages.BenefitCodeEntry.prototype.setMatterBillingCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.benefits_messages.FetchBenefitCodesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.benefits_messages.FetchBenefitCodesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.benefits_messages.FetchBenefitCodesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.benefits_messages.FetchBenefitCodesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.FetchBenefitCodesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
entriesList: jspb.Message.toObjectList(msg.getEntriesList(),
    proto.benefits_messages.BenefitCodeEntry.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.benefits_messages.FetchBenefitCodesResponse}
 */
proto.benefits_messages.FetchBenefitCodesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.benefits_messages.FetchBenefitCodesResponse;
  return proto.benefits_messages.FetchBenefitCodesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.benefits_messages.FetchBenefitCodesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.benefits_messages.FetchBenefitCodesResponse}
 */
proto.benefits_messages.FetchBenefitCodesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.benefits_messages.BenefitCodeEntry;
      reader.readMessage(value,proto.benefits_messages.BenefitCodeEntry.deserializeBinaryFromReader);
      msg.addEntries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.benefits_messages.FetchBenefitCodesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.benefits_messages.FetchBenefitCodesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.benefits_messages.FetchBenefitCodesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.FetchBenefitCodesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.benefits_messages.BenefitCodeEntry.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BenefitCodeEntry entries = 1;
 * @return {!Array<!proto.benefits_messages.BenefitCodeEntry>}
 */
proto.benefits_messages.FetchBenefitCodesResponse.prototype.getEntriesList = function() {
  return /** @type{!Array<!proto.benefits_messages.BenefitCodeEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.benefits_messages.BenefitCodeEntry, 1));
};


/**
 * @param {!Array<!proto.benefits_messages.BenefitCodeEntry>} value
 * @return {!proto.benefits_messages.FetchBenefitCodesResponse} returns this
*/
proto.benefits_messages.FetchBenefitCodesResponse.prototype.setEntriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.benefits_messages.BenefitCodeEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.benefits_messages.BenefitCodeEntry}
 */
proto.benefits_messages.FetchBenefitCodesResponse.prototype.addEntries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.benefits_messages.BenefitCodeEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.benefits_messages.FetchBenefitCodesResponse} returns this
 */
proto.benefits_messages.FetchBenefitCodesResponse.prototype.clearEntriesList = function() {
  return this.setEntriesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
matterBillingCodesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest}
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest;
  return proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest}
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addMatterBillingCodes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatterBillingCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string matter_billing_codes = 1;
 * @return {!Array<string>}
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest.prototype.getMatterBillingCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest} returns this
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest.prototype.setMatterBillingCodesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest} returns this
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest.prototype.addMatterBillingCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest} returns this
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesRequest.prototype.clearMatterBillingCodesList = function() {
  return this.setMatterBillingCodesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
benefitIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse}
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse;
  return proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse}
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addBenefitIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBenefitIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 benefit_ids = 1;
 * @return {!Array<number>}
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse.prototype.getBenefitIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse} returns this
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse.prototype.setBenefitIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse} returns this
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse.prototype.addBenefitIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse} returns this
 */
proto.benefits_messages.ListBenefitIdsByMatterBillingCodesResponse.prototype.clearBenefitIdsList = function() {
  return this.setBenefitIdsList([]);
};


/**
 * @enum {number}
 */
proto.benefits_messages.UsesPerYearDefinition = {
  TOTAL: 0,
  PER_COVERED_PERSON: 1
};

/**
 * @enum {number}
 */
proto.benefits_messages.BillingTypeEnum = {
  ESTATE_PLANNING: 0,
  FIXED_HIGH_VALUE: 1,
  FIXED_LOW_VALUE: 2,
  HOURLY: 3,
  HOURLY_OR_FIXED: 4
};

goog.object.extend(exports, proto.benefits_messages);
